import { isMacAppStore } from '@/lib/appDistribution';

// Event snapshots may create a partial task containing only goal/status. A
// fetched task explicitly includes both boundaries, using null for cloud.
export function hasMacTaskBoundary(task) {
  return !!task && Object.hasOwn(task, 'localProject') && Object.hasOwn(task, 'localDesktop');
}
/**
 * Decides whether a Mac project chat must render read-only (history visible,
 * composer blocked).
 *
 * Web cannot control Mac project chats. Mobile requires a connected Mac; send
 * controls still verify current access before running. Empty history alone does
 * not establish a disconnected Mac or revoked access.
 */
export function resolveMacProjectReadOnly({
  platform,
  isMacProjectChat,
  revokedAt,
  remoteConnection,
  taskDetailsPending,
} = {}) {
  // A cold Work history load has no execution boundary until task detail
  // arrives. Store controls must not briefly treat that unknown task as cloud.
  if (platform === 'macos' && isMacAppStore() && taskDetailsPending) return true;
  if (!isMacProjectChat) return false;
  if (platform === 'web' || (platform === 'macos' && isMacAppStore())) return true;
  if ((platform === 'ios' || platform === 'android') && remoteConnection && remoteConnection !== 'connected') return true;

  return !!revokedAt;
}

export default resolveMacProjectReadOnly;
